export default __webpack_public_path__ + "static/media/caloLogo.d455d0a1.svg";